import React from 'react';
import { bool, func } from 'prop-types';
import { Button } from 'antd';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import './style.scss';

function MentorshipOnboardingFooter({ handleBackClick, handleProceedClick, loading }) {
  return (
    <div className="mentorship-onboarding-footer p8">
      <div className="footer-buttons-wrapper arc-d-flex">
        <Button className="back-button" size="large" onClick={handleBackClick}>
          <I18nCustomFormatter id="back-button" />
        </Button>
        <Button className="proceed-button" type="primary" size="large" onClick={handleProceedClick} loading={loading}>
          <I18nCustomFormatter id="proceed-button" />
        </Button>
      </div>
    </div>
  );
}

MentorshipOnboardingFooter.propTypes = {
  handleBackClick: func.isRequired,
  handleProceedClick: func.isRequired,
  loading: bool.isRequired,
};

export default MentorshipOnboardingFooter;
